/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let log: any;
declare let AnalyticsEvents: any;
declare let WebDefine: any;
declare let sys: any;
declare let WebServerType: any;
declare let FunctionUtils: any;
declare let AndroidBridge: any;
declare let EDITOR: any;
declare let StringUtils: any;
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { wsClient } from '@/net/WebSocketClient'
import { MsgIDs } from '@/defines/MsgIDs'
import { HallTabViews } from '@/defines/EnumDefine'

export class AddCashModule extends ModuleBase {
  public PAY_DURATION = 5

  //支付方式数据
  public payment_: any = {}
  public payWheel_: any = {}
  public wheelRewardList: any = {}

  public getedGoodsList_ = false

  //支付数据
  public firstPay_ = false
  public goodsList_: any = []
  public customGoldGoods_: any = null
  public bankruptGoodsList_: any = []
  public goodsInfos_: any = null
  public payCountdown_ = 0
  public payCountdownHander_: any = null
  public payConfig_: any = null

  //当前充值入口
  public payFrom_ = 1 //1是充值界面；2是首充充值界面；3是VIP卡充值界面

  public backAll: any = null

  init(): void {
    this.payment_ = {}
    this.payWheel_ = {}
    this.wheelRewardList = {}

    this.getedGoodsList_ = false

    this.firstPay_ = false
    this.goodsList_ = []
    this.customGoldGoods_ = null
    this.bankruptGoodsList_ = []
    this.goodsInfos_ = null
    this.payCountdown_ = 0
    this.payCountdownHander_ = null
  }

  onClear(): void {
    this.payment_ = {}
    this.payWheel_ = {}
    this.wheelRewardList = {}

    this.getedGoodsList_ = false

    this.firstPay_ = false
    this.goodsList_ = []
    this.customGoldGoods_ = null
    this.bankruptGoodsList_ = []
    this.goodsInfos_ = null
    this.payCountdown_ = 0
    this.unschedulePayCountdown_()
  }

  unschedulePayCountdown_() {
    if (this.payCountdownHander_) {
      clearTimeout(this.payCountdownHander_)
      this.payCountdownHander_ = null
    }
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClient2ProxyAckNewPayRecord'] = function (msg: any) {
      const count = msg.PayRecordList.length
      log('[af_cash_success] onClient2ProxyAckNewPayRecord count', count)
      if (msg.PayRecordList && msg.PayRecordList.length > 0) {
        const orders = []
        for (let i = 0; i < msg.PayRecordList.length; i++) {
          const order = msg.PayRecordList[i].Order
          const isSend = hall.hallModule.isSendAFEvent(order)
          if (isSend) {
            log('[af_cash_success] push event')
            orders[orders.length + 1] = order

            // base.sdkWrapper.traceAppEvent("af_cash_success", {
            //     af_revenue: Number(msg.PayRecordList[i].Amount),
            //     af_customer_user_id: hall.userModule.userId,
            //     order: order
            // })

            base.analyticsModule.logEvent(AnalyticsEvents.purchase, {
              af_revenue: Number(msg.PayRecordList[i].Amount),
              af_customer_user_id: hall.userModule.userId,
              order: order,
            })
          }
        }

        const msgData = {
          UserID: hall.userModule.userId,
          Order: orders,
        }
        // 通知后端充值成功事件已发送，可以把是否已获取标记更改了
        hall.addCashModule.sendReqNewPayUpdate(msgData)
      }
    }
  }

  onPreloadData(): void {
    log('AddCashModule onPreloadData')
    this.postGetPayMent()
    this.postGetPayWheel()
    this.postPayConfigReq()
    this.postGoodsInfoReq()
  }

  sendReqNewPayRecord() {
    const message = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.Client2ProxyReqNewPayRecord, message)
  }

  sendReqNewPayUpdate(message) {
    wsClient.send(MsgIDs.Client2ProxyReqNewPayUpdate, message)
  }
  //-------------------------------------首充转盘------------------------------

  //请求支付渠道数据
  postGetPayMent() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.getPayMent, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.payment_ = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.PayMentChange)
        } else {
          log('postGetPayMent failFun')
        }
      })
      .catch((_error: any) => {
        log('error:', error)
      })
  }

  //请求转盘列表
  postGetPayWheel() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.getPayWheel, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.payWheel_ = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.PayWheelChange)
        } else {
          log('postGetPayWheel failFun')
        }
      })
      .catch((_error: any) => {
        log('error:', error)
      })
  }

  //请求转盘记录
  postWheelRewardList() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.wheelRewardList, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.wheelRewardList = respJson.data.list
          hall.eventDispatcher.emit(hall.EventDefine.WheelReward)
        } else {
          log('postWheelRewardList failFun')
        }
      })
      .catch((_error: any) => {
        log('error:', error)
      })
  }

  //点击首充转盘
  postPayWheelSpin() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.payWheelSpin, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          const spinResult = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.PayWheelSpin, spinResult)
        } else {
          log('postPayWheelSpin failFun')
        }
      })
      .catch((_error: any) => {
        log('error:', error)
      })
  }

  //--获取支付方式后端数据
  getPayMent() {
    return this.payment_
  }

  getWheelRewardList() {
    return this.wheelRewardList
  }

  getPayWheel() {
    return this.payWheel_
  }

  //-- 未购买 vip 则显示 vip；已购买则显示 shop
  toAddCashView() {
    hall.hallModule.showHallTabView(HallTabViews.DepositPanel)
  }

  //-------------------------------------商店------------------------------

  //支付配置
  postPayConfigReq() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.getPayConfig, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.payConfig_ = respJson.data
        }
      })
      .catch((_error: any) => {
        log('postPayConfigReq failFun:', error)
      })
  }

  //商品列表
  postGoodsInfoReq() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.goodslist, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.disposeGoods_(respJson.data)
          this.getedGoodsList_ = true
          if (hall.popupViewModule.isFirstAdd == false) {
            hall.eventDispatcher.emit(hall.EventDefine.TryAddPopupView, hall.Constants.GoodsList)
          }

          hall.eventDispatcher.emit(hall.EventDefine.GoodsListChange)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新首充红点

          hall.eventDispatcher.emit(hall.EventDefine.TryAddPopupView, hall.Constants.GoodsList)
        }
      })
      .catch((_error: any) => {
        log('postPayConfigReq failFun:', error)
      })
  }

  disposeGoods_(goodsInfos) {
    this.firstPay_ = goodsInfos.first_pay == 1 //1:还有首充 ， 0：已经完成首充

    this.goodsInfos_ = goodsInfos

    this.goodsList_ = []
    for (let i = 0; i < goodsInfos.list.length; i++) {
      // 1:vip卡 2:充值 3:礼包(破产礼包)
      const v = goodsInfos.list[i]
      if (v.type == 2) {
        if (v.min_money != 0 && v.max_money != 0) {
          this.customGoldGoods_ = v
        } else {
          this.goodsList_.push(v)
        }
      } else if (v.type == 3) {
        this.bankruptGoodsList_.push(v)
      }
    }
    this.goodsList_.sort((a, b) => {
      if (a.min_money !== 0 && a.max_money !== 0) {
        return 1 // 将 a 排在后面
      }

      if (b.min_money !== 0 && b.max_money !== 0) {
        return -1 // 将 a 排在前面
      }
      return a.money - b.money
    })
  }

  isUseNewConfig() {
    if (this.payConfig_) {
      return this.payConfig_.isConfig == 1
    }
    return false
  }

  isGetedGoodsList() {
    return this.getedGoodsList_
  }

  getGoodsInfos() {
    return this.goodsInfos_
  }

  getGoodsList() {
    return this.goodsList_
  }

  getCustomGoldGoods() {
    return this.payConfig_
  }

  getPayConfig_() {
    return this.customGoldGoods_
  }

  getBankruptGoods(goodsId) {
    if (goodsId == null) {
      if (this.bankruptGoodsList_.length > 0) {
        return this.bankruptGoodsList_[1]
      }
    }
    for (let i = 0; i < this.bankruptGoodsList_.length; i++) {
      if (this.bankruptGoodsList_[i].id == goodsId) {
        return this.bankruptGoodsList_[i]
      }
    }
    return null
  }

  isFirstAddCash() {
    return this.firstPay_
  }

  //--判断是否有支付钱包选择，没有就直接跳过，直接去支付
  checkIsMent() {
    const keys = Object.keys(this.payment_).length
    if (keys > 0) {
      const mentkeys = Object.keys(this.payment_['list']).length
      return mentkeys != 0
    } else {
      return false
    }
  }

  getGoodsRatio() {
    const goodsList = this.getGoodsList()
    if (goodsList) {
      let discountMax = 0
      for (let i = 0; i < goodsList.length; i++) {
        const money = goodsList[i].money
        let getTotal =
          money +
          Math.floor(money * goodsList[i].gst) +
          Math.floor(money * goodsList[i].reward) +
          Number(goodsList[i].diamond)
        const isFirst = this.isFirstAddCash()
        if (isFirst) {
          getTotal =
            money +
            Math.floor(money * goodsList[i].gst) +
            Math.floor(money * goodsList[i].first_reward) +
            Number(goodsList[i].diamond)
        }
        const discount = getTotal / money
        if (discount > discountMax) {
          discountMax = discount
        }
      }
      return discountMax
    }
    return 0
  }

  getHallShowRatio() {
    const geted = this.isGetedGoodsList()
    if (!geted) {
      log('HallPanel:setShopRatio_ return by not get goodsList')
      return 0
    }
    const getviped = hall.vipModule.isGetedVipInfos()
    if (!getviped) {
      log('HallPanel:setShopRatio_ return by not get VipInfos')
      return 0
    }
    let ratio = 0

    const goodsInfos = this.getGoodsInfos()
    if (goodsInfos.first_pay == 1) {
      if (goodsInfos.reward > 0) {
        ratio = goodsInfos.reward
      } else {
        ratio = this.getGoodsRatio()
      }
    } else {
      const buyedVip = hall.vipModule.isBuyedVip()
      if (!buyedVip) {
        //还没买vip礼包，展示最高的vip折扣
        ratio = hall.vipModule.getVipMaxDiscount()
      } else {
        ratio = this.getGoodsRatio()
      }
    }
    return ratio
  }

  //支付流程增加钱包选择 --支付接口
  h5Pay(goodsId, amount, paymentData, callback) {
    paymentData = paymentData || { walletType: 0, phone: '', number: '' }
    log('AddCashModule:h5Pay UserID =', typeof hall.userModule.userId)
    log('AddCashModule:h5Pay UserID =', hall.userModule.userId)
    log('AddCashModule:h5Pay goodsId =', goodsId)
    log('AddCashModule:h5Pay amount =', amount)
    log('AddCashModule:h5Pay walletType =', paymentData.walletType)
    log('AddCashModule:h5Pay phone =', paymentData.phone)
    log('AddCashModule:h5Pay number =', paymentData.number)

    //if (!hall.userModule.hasBoundPhoneNum()) {
    //    //base.uiHudSystem.show("RegisterBindPhonePanel");
    //    base.uiHudSystem.show("BindingPhonePanel");
    //    callback(false, { needPhoneNum: true })
    //    return;
    //}

    //判断是否是有支付流程的数据，没有的话就用老的方法
    const isHasMent = this.checkIsMent()
    if (!isHasMent) {
      this.h5Pay0(goodsId, amount, callback)
      return
    }

    if (this.payCountdown_ > 0) {
      const msg = StringUtils.Format(hall.Language.AddCashPayH5, this.payCountdown_)
      base.toast(msg)
      return
    }

    this.unschedulePayCountdown_()
    this.payCountdown_ = this.PAY_DURATION

    const runCountdown = () => {
      this.payCountdownHander_ = setTimeout(() => {
        this.payCountdown_ -= 1
        if (this.payCountdown_ > 0) {
          runCountdown()
        } else {
          this.unschedulePayCountdown_()
        }
      }, 1000)
    }
    runCountdown() // 启动倒计时

    const data = {
      userId: hall.userModule.userId,
      channelId: base.channelId,

      payType: paymentData.id,
      goodsId: goodsId,
      payAmt: amount,
      walletType: paymentData.walletType,
      phone: hall.userModule.phoneNum,
      number: paymentData.number,
      payerUserDeviceId: base.app.getUUID(),
      payerUserDeviceOS: sys.os.toUpperCase(),
    }

    base.uiHudSystem.show('SystemWaiting')
    base.httpUtil
      .postJson(WebDefine.createPayOrder, data, WebServerType.PAY)
      .then((respJson) => {
        log(respJson, 'AddCashModule:h5Pay successFun response')
        base.uiHudSystem.hide('SystemWaiting')
        if (respJson.code == 200) {
          const payment_link = respJson.data.payment_link

          // 浏览器打开这个地址
          // base.sdkWrapper.traceAppEvent("af_cash", {
          //     af_customer_user_id: hall.userModule.userId
          // })

          base.analyticsModule.logEvent(AnalyticsEvents.add_to_cart, {
            af_customer_user_id: hall.userModule.userId,
          })

          const urlParams = new URLSearchParams(payment_link)
          const prepayId = urlParams.get('prepay_id')
          const orderId = urlParams.get('order_id')
          const arrData = {}
          arrData['prepayId'] = prepayId
          arrData['order_id'] = orderId
          arrData['payment_link'] = payment_link
          arrData['channleId'] = base.channelId
          const payUrl = payment_link //"https://86a.bet/lp/pay.html?args=" +

          if (globalThis.dbStartPayTime) {
            const a = Date.now() - globalThis.dbStartPayTime
            const dbTimePay = Math.floor(a / 1000)
            FunctionUtils.SM_EVENT_TIME('game_pay_loading_time_new2', dbTimePay)
            globalThis.dbStartPayTime = null
          }

          const urlParams2 = new URLSearchParams(window.location.search)
          const isApkWebview = urlParams2.get('hidePWA') //是否是apk webview
          if (isApkWebview) {
            try {
              if (AndroidBridge && AndroidBridge.openExternal) {
                //AndroidBridge这个在纯网页会报未定义报错
                AndroidBridge.openExternal(payUrl)
              }
            } catch {
              top.location.href = payUrl
            }
          } else {
            if (!EDITOR && sys.isBrowser && sys.os == sys.OS.ANDROID) {
              sys.openURL(payUrl)
            } else {
              globalThis.open_pay_url_confirm = true //打点用
              base.app.openURL(payUrl, hall.Language.open_pay_url_confirm)
            }
          }

          callback(true)
        } else {
          if (respJson.code == 501 || respJson.code == 502) {
            // phone number does not exist
            callback(false, { kyc: true })
          } else {
            base.toast(respJson.message)
            callback(false)
          }
        }
      })
      .catch((_error: any) => {
        base.uiHudSystem.hide('SystemWaiting')
        log('h5PayError:', error)
        //gt.dump(respJson, "AddCashModule:h5Pay failFun respJson")
        base.toast('Please check the network and try again')
        callback(false)
      })
  }

  h5Pay0(goodsId, amount, callback) {
    log('AddCashModule:h5Pay UserID =', typeof hall.userModule.userId)
    log('AddCashModule:h5Pay UserID =', hall.userModule.userId)
    log('AddCashModule:h5Pay goodsId =', goodsId)
    log('AddCashModule:h5Pay amount =', amount)

    if (this.payCountdown_ > 0) {
      const msg = StringUtils.Format(hall.Language.AddCashPayH5, this.payCountdown_)
      base.toast(msg)
      return
    }

    this.unschedulePayCountdown_()
    this.payCountdown_ = this.PAY_DURATION

    const runCountdown = () => {
      this.payCountdownHander_ = setTimeout(() => {
        this.payCountdown_ -= 1
        if (this.payCountdown_ > 0) {
          runCountdown()
        } else {
          this.unschedulePayCountdown_()
        }
      }, 1000)
    }
    runCountdown() // 启动倒计时

    const data = {
      userId: hall.userModule.userId,
      channelId: base.channelId,
      phone: hall.userModule.phoneNum,
      payType: this.payConfig_.info.pay_type,
      goodsId: goodsId,
      payAmt: amount,
    }

    // base.uiHudSystem.show("SystemPayTips")
    base.uiHudSystem.show('SystemWaiting')
    base.httpUtil
      .postJson(WebDefine.createPayOrder, data, WebServerType.PAY)
      .then((respJson) => {
        log(respJson, 'AddCashModule:h5Pay successFun response')
        base.uiHudSystem.hide('SystemWaiting')
        if (respJson.code == 200) {
          const payment_link = respJson.data.payment_link

          // 浏览器打开这个地址
          // base.sdkWrapper.traceAppEvent("af_cash", {
          //     af_customer_user_id: hall.userModule.userId
          // })

          base.analyticsModule.logEvent(AnalyticsEvents.add_to_cart, {
            af_customer_user_id: hall.userModule.userId,
          })

          //cc.UserDefault:getInstance():setBoolForKey(gt.SaveKeyDef.SAVE_CASH_REQ, true)
          //cc.UserDefault:getInstance():flush()

          const payUrl = payment_link
          const urlParams = new URLSearchParams(window.location.search)
          const isApkWebview = urlParams.get('hidePWA') //是否是apk webview
          if (isApkWebview) {
            try {
              if (AndroidBridge && AndroidBridge.openExternal) {
                //AndroidBridge这个在纯网页会报未定义报错
                AndroidBridge.openExternal(payUrl)
              }
            } catch {
              top.location.href = payUrl
            }
          } else {
            if (!EDITOR && sys.isBrowser && sys.os == sys.OS.ANDROID) {
              sys.openURL(payUrl)
            } else {
              globalThis.open_pay_url_confirm = true //打点用
              base.app.openURL(payUrl, hall.Language.open_pay_url_confirm)
            }
          }

          callback(true)
        } else {
          if (respJson.code == 501 || respJson.code == 502) {
            // phone number does not exist
            callback(false, { kyc: true })
          } else {
            base.toast(respJson.message)
            callback(false)
          }
        }
      })
      .catch((_error: any) => {
        base.uiHudSystem.hide('SystemWaiting')
        log('h5PayError:', error)
        //gt.dump(respJson, "AddCashModule:h5Pay0 failFun respJson")
        base.toast(hall.Language.AddCashModule_failFun_tip)
        callback(false)
      })
  }

  //延迟请求签到数据（有时差）
  sendSignInfo() {
    setTimeout(() => {
      hall.signModule.sendSignConfig()
    }, 3000)
  }

  // 是否已获取到弹窗判断的数据
  isGetedPopupData() {
    return this.getedGoodsList_
  }

  // 是否需要弹窗
  popupView() {
    //现在是新人礼包
    const welcomeEnd = hall.welcomeGiftModule.isWelcomeEnd()
    if (!welcomeEnd && hall.welcomeGiftModule.welocmeInfo_ != null) {
      // hall.popupViewModule.addPopupView(PopupViews.WelcomePopPanel);
    }
  }

  //是否侧边栏展示这个活动
  isShowFirstBind() {
    const goodsInfo = this.getGoodsInfos()
    if (goodsInfo && goodsInfo.first_pay == 1) {
      return true
    }

    return false
  }

  // 是否需要弹窗
  popupFirstView() {
    const goodsInfo = this.getGoodsInfos()
    if (goodsInfo && goodsInfo.first_pay == 1) {
      hall.popupViewModule.addPopupView(PopupViews.FirstDepositPanel)
    }
  }
}
